import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    width: '50%',
    textAlign: 'center',
    padding: '20px'
  }
});

function Error() {
  const classes = useStyles();

  return <Container className={classes.container}>問題が発生しました。サインアウトして再度実行してください。</Container>;
}

export default Error;
